<template>
  <div>
    <!-- on-ok="handleOk" :closable="false" -->
    <a-modal v-model="viewModal" :width="1500" title="Import Alumni Profile" :closable="false" :maskClosable="false">
      <template slot="footer">
        <a-button @click="onCloseDataModal"> close </a-button>
        <a-button @click="onSubmitUpload" :loading="!isLoaded" type="primary">
          Submit Upload
          <!-- {{ countInsert }} -->
        </a-button>
      </template>
      <!-- {{ fileList }} -->
      <h6 class="mt-5 mb-10">
        Input Data
        <p class="mt-0 mb-0">
          Example file :
          <a target="_blank"
            href="https://docs.google.com/spreadsheets/d/1QgQg2HmgF2qkLBHjMxfdX9SyPqyuuoAWYSqXaDEu_1g/edit?usp=sharing">File
            (.xlsx)</a>
        </p>
      </h6>
      <a-upload-dragger name="file" :file-list="fileList" @change="handleChange">
        <p class="ant-upload-drag-icon">
          <a-icon type="inbox" />
        </p>
        <p class="ant-upload-text">Click or drag file to this area to upload</p>
      </a-upload-dragger>
      <br />

      <!-- <div class="modal-info"> -->
      <!-- table view data -->
      <a-row>
        <a-col :span="4">
          <a-tag color="green">
            <p class="text-center mt-5 mb-0 font-bold">
              Alumni
              <span class="text-danger">{{ dataTable.length }}</span> person
            </p>
          </a-tag>
        </a-col>
        <a-col :span="16">
          <span v-if="!isLoaded">
            <a-progress :stroke-color="{
              from: '#108ee9',
              to: '#87d068',
            }" :percent="importProgress" status="active" />
          </span>
        </a-col>
        <a-col :span="4" style="text-align:right">
          <a-tag color="blue">
            <p class="text-center mt-5 mb-0 font-bold">
              Complete :
              <span class="text-info">{{ importComplete }}</span>
            </p>
          </a-tag>
          <a-tag color="red">
            <p class="text-center mt-5 mb-0 font-bold">
              Failed :
              <span class="text-danger">{{ importFailed }}</span>
            </p>
          </a-tag>
        </a-col>
      </a-row>


      <a-table bordered :columns="columns" :data-source="dataTable" :loading="loadingSetTable" :pagination="true"
        size="small" class="mt-20 mb-20" :scroll="{ x: 1500 }">
        <!-- <template slot="status_import" slot-scope="text, record, index">
          <div v-if="processImport.length != 0">
            <a-icon :style="{ fontSize: '32px', color: '#F55050' }"
              v-if="processImport[parseInt(record.sequence)].status === 'error'" type="exclamation-circle" />
            <a-icon :style="{ fontSize: '32px', color: '#1F8A70' }" v-if="
              processImport[parseInt(record.sequence)].status === 'success'
            " type="check-square" />
          </div>
        </template> -->
        <template slot="status_import" slot-scope="text, record, index">
          <div>
            <a-icon :style="{ fontSize: '25px', color: '#F55050' }" v-if="text === 'error'" type="exclamation-circle" />
            <a-icon :style="{ fontSize: '25px', color: '#1F8A70' }" v-if="text === 'complete'" type="check-square" />
          </div>
        </template>
        <template slot="status_detail" slot-scope="text, record, index">
          <span v-if="record.status_import === 'error'">
            <p :style="{ color: '#F55050' }">{{ text }}</p>
          </span>
          <span v-if="record.status_import === 'complete'">
            <p :style="{ color: '#1F8A70' }">Import Complete</p>
          </span>
        </template>
        <template slot="Name" slot-scope="text, record">
          <p class="mt-0 mb-0">
            {{
              `${record.academic_title} ${record.title_name} ${record.eng_first_name} ${record.eng_middle_name}
            ${record.eng_last_name}`
            }}
          </p>
          <p class="mt-0 mb-0">
            {{
              `${record.thai_first_name} ${record.thai_middle_name} ${record.thai_last_name}`
            }}
          </p>
        </template>
        <template slot="former_name" slot-scope="text, record">
          <p class="mt-0 mb-0">
            {{
              `${record.former_eng_first_name} ${record.former_eng_middle_name} ${record.former_eng_last_name}`
            }}
          </p>
          <p class="mt-0 mb-0">
            {{
              `${record.former_thai_first_name} ${record.former_thai_middle_name} ${record.former_thai_last_name}`
            }}
          </p>
        </template>
        <template slot="Contact" slot-scope="text, record">
          <p class="mt-0 mb-0">
            {{
              `${record.former_eng_first_name} ${record.former_eng_middle_name} ${record.former_eng_last_name}`
            }}
          </p>
          <p class="mt-0 mb-0">
            {{
              `${record.former_thai_first_name} ${record.former_thai_middle_name} ${record.former_thai_last_name}`
            }}
          </p>
        </template>
        <template slot="Nationality" slot-scope="text, record">
          {{ mapDataOptionsText(optionNationality, record.nationality) }}
        </template>
        <template slot="Major" slot-scope="text, record">
          {{ mapDataOptionsText(optionMajor, record.major) }}
        </template>
      </a-table>
      <!-- </div> -->
      <!-- <p class="mt-0 mb-0">{{ indexLoad }}</p> -->
    </a-modal>
  </div>
</template>

<script>
import readXlsxFile from "read-excel-file";
import _tableUpload from "./table-import/tableImportAlumniProfile";
export default {
  props: {
    viewModal: {
      type: Boolean,
      default: false,
    },
    onCloseModal: {
      type: Function
    }
  },
  computed: {
    importProgress() {
      return Number.parseFloat((this.importComplete + this.importFailed) * 100 / this.dataTable.length).toFixed(2);
    }
  },
  data() {
    return {
      // table connect api status
      indexLoad: "",
      processImport: [],
      indexErrorName: [],
      indexErrorContact: [],
      //
      dataTable: [],
      columns: _tableUpload.excleHead,
      // file upload
      fileList: [],
      uploading: false,
      errorFile: "",
      loading: false,
      // option
      optionTitle: [],
      optionAcademicTitle: [],
      optionNationality: [],
      optionProgram: [],
      optionMajor: [],
      optionGradStatus: [],
      //
      arrName: [],
      arrNameFormer: [],
      arrContact: [],
      arrContactFormer: [],
      loadingSetTable: false,
      startInsertName: false,
      // count load
      isLoaded: true,
      //amount import
      importComplete: 0,
      importFailed: 0,
      countInsert: 0,
    };
  },
  mounted() {
    this.getDataOptions();
  },
  methods: {
    async getDataOptions() {
      const fetchTitle = await this.$http.get(`/student_affair/title-name/`);
      const fetchNationality = await this.$http.get(
        `/student_affair/nationality/`
      );
      const fetchProgram = await this.$http.get(
        `/student_affair/program-code/`
      );
      const fetchMajor = await this.$http.get(`/student_affair/major/`);
      const fetchGradStatus = await this.$http.get(
        `/student_affair/graduate-status/`
      );
      const fetchAcademin = await this.$http.get(
        `/student_affair/academic-title/`
      );
      Promise.all([
        fetchTitle,
        fetchNationality,
        fetchProgram,
        fetchMajor,
        fetchGradStatus,
        fetchAcademin,
      ])
        .then((response) => {
          return Promise.all(response.map((r) => r.data));
        })
        .then(([listA, listB, listC, listD, listE, listF]) => {
          this.optionTitle = listA.map((item) => {
            return {
              id: item.id,
              textTH: `${item.name_thai}`,
              textEn: `${item.name_eng}`,
              value: item.id,
            };
          });
          this.optionNationality = listB.map((item) => {
            return {
              id: item.id,
              textTH: `${item.name_thai}`,
              textEn: `${item.name_eng}`,
              value: item.id,
            };
          });
          this.optionProgram = listC.map((item) => {
            return {
              id: item.id,
              textTH: `${item.name_thai}`,
              textEn: `${item.name_eng}`,
              value: item.id,
            };
          });
          this.optionMajor = listD.map((item) => {
            return {
              id: item.id,
              textTH: `${item.name_thai}`,
              textEn: `${item.name_eng}`,
              value: item.id,
            };
          });
          this.optionGradStatus = listE.map((item) => {
            return {
              id: item.id,
              textTH: `${item.name_thai}`,
              textEn: `${item.name_eng}`,
              value: item.id,
            };
          });
          this.optionAcademicTitle = listF.map((item) => {
            return {
              id: item.id,
              textTH: `${item.name_thai}`,
              textEn: `${item.name_eng}`,
              value: item.id,
            };
          });
        })
        .catch((error) => {
          this.$emit("errorNotification", {
            errorMsg: error.response.status,
            urlPath: `fail call option list`,
          });
        });
    },
    onCloseDataModal() {
      this.fileList = [];
      this.onCloseModal();
      // (this.dataTable = []), this.$emit("hideModal");
    },
    checkBlank(val) {
      return !["", null, "null"].includes(val) ? val : "-";
    },
    convertDateNumberToString(excelDate) {
      const { getJsDateFromExcel } = require("excel-date-to-js");
      var dateConvert = ""
      try {
        dateConvert = this.moment(new Date(getJsDateFromExcel(excelDate))).format(
          "YYYY-MM-DD"
        )
      } catch (e) {
        dateConvert = this.moment(new Date(excelDate)).format(
          "YYYY-MM-DD"
        );
      }
      return dateConvert;
    },
    handleChange(info) {
      this.loadingSetTable = true;
      this.importComplete = 0
      this.importFailed = 0
      this.dataTable = [];
      let fileList = [...info.fileList];
      fileList = fileList.slice(-1);
      this.processImport = [];

      // 2. read from response and show file link
      fileList = fileList.map((file) => {
        if (file.response) {
          let xlsxfile = info.file.originFileObj;
          readXlsxFile(xlsxfile).then((rows) => {
            for (let index = 0; index < rows.length; index++) {
              this.processImport.push({
                index: index,
                status: "wait",
                student_id: rows[index][3],
              });

              // console.log(rows[index]);
              if (index > 1) {
                this.dataTable.push({
                  // status import
                  descriptImport: "",
                  status_import: "",
                  //describe
                  status_detail: "",
                  // not use
                  sequence: index, // not use
                  // not use
                  membership_id: rows[index][1],
                  muicaa_member: rows[index][2], // index 0 ref sequence number
                  student_id: rows[index][3],
                  academic_title: this.checkBlank(rows[index][4]),
                  title_name: this.checkBlank(rows[index][5]),
                  // name en
                  eng_first_name: this.checkBlank(rows[index][6]),
                  eng_middle_name: this.checkBlank(rows[index][7]),
                  eng_last_name: this.checkBlank(rows[index][8]),
                  //academic_title_en: this.checkBlank(rows[index][9]), //not use
                  // name currently
                  //title_name_th: this.checkBlank(rows[index][10]),/ /not use
                  thai_first_name: this.checkBlank(rows[index][11]),
                  thai_middle_name: this.checkBlank(rows[index][12]),
                  thai_last_name: this.checkBlank(rows[index][13]),
                  // fomer name
                  former_eng_first_name: this.checkBlank(rows[index][14]),
                  former_eng_middle_name: this.checkBlank(rows[index][15]),
                  former_eng_last_name: this.checkBlank(rows[index][16]),
                  former_thai_first_name: this.checkBlank(rows[index][17]),
                  former_thai_middle_name: this.checkBlank(rows[index][18]),
                  former_thai_last_name: this.checkBlank(rows[index][19]),
                  // detail background
                  nationality: this.mapDataOptions(
                    this.optionNationality,
                    this.checkBlank(rows[index][20])
                  ),
                  major: this.mapDataOptions(
                    this.optionMajor,
                    this.checkBlank(rows[index][21])
                  ), /// or programcode
                  minor: this.checkBlank(rows[index][22]),
                  concentration: rows[index][23],
                  grade: rows[index][24],
                  graduate_status_remark: rows[index][25],
                  graduate_year: rows[index][26],
                  graduate_date:
                    rows[index][27] !== ""
                      ? this.convertDateNumberToString(rows[index][27]) // this.moment(rows[index][25]).format("YYYY-MM-DD")//this.moment(rows[index][25]).format("YYYY-MM-DD")
                      : "",
                  // contact currently
                  phone_home: this.checkBlank(rows[index][28]),
                  phone_number: this.checkBlank(rows[index][29]),
                  email: this.checkBlank(rows[index][30]),
                  address: this.checkBlank(rows[index][31]),
                  social_instagram: "-",
                  social_facebook: "-",
                  social_line: "-",
                  // former contact
                  former_phone_home: this.checkBlank(rows[index][32]),
                  former_phone_number: this.checkBlank(rows[index][33]),
                  former_email: this.checkBlank(rows[index][34]),
                  former_address: this.checkBlank(rows[index][35]),
                  former_social_instagram: "-",
                  former_social_facebook: "-",
                  former_social_line: "-",
                });
              }
            }
          });
          file.url = file.response.url;
        }
        return file;
      });
      this.fileList = fileList;
      this.loadingSetTable = false;
    },
    async onSubmitUpload() {
      // ////console.log(this.dataTable)
      this.countInsert = 0;
      this.isLoaded = false;
      for (let listUp = 0; listUp < this.dataTable.length; listUp++) {
        var jsonBody = {};
        var jsonName = {};
        var jsonFormerName = {};
        var jsonContact = {};
        var jsonFormerContact = {};

        const keys = Object.keys(this.dataTable[listUp]);
        for (let i = 0; i < keys.length; i++) {
          if (!["sequence"].includes(keys[i])) {
            // -----> main profile
            if (
              ![
                "title_name",
                "academic_title",
                "eng_first_name",
                "eng_last_name",
                "eng_middle_name",
                "thai_first_name",
                "thai_last_name",
                "thai_middle_name",
                "former_eng_first_name",
                "former_eng_last_name",
                "former_eng_middle_name",
                "former_thai_first_name",
                "former_thai_last_name",
                "former_thai_middle_name",
                "address",
                "email",
                "social_instagram",
                "social_facebook",
                "social_line",
                "phone_number",
                "phone_home",
                "former_address",
                "former_email",
                "former_social_instagram",
                "former_social_facebook",
                "former_social_line",
                "former_phone_number",
                "former_phone_home",
              ].includes(keys[i])
            ) {
              // ////console.log(i,keys[i],'----->',this.dataTable[listUp][keys[i]]);
              jsonBody[keys[i]] = this.dataTable[listUp][keys[i]];
            }
            // -----> main name
            else if (
              [
                "title_name",
                "academic_title",
                "eng_first_name",
                "eng_last_name",
                "eng_middle_name",
                "thai_first_name",
                "thai_last_name",
                "thai_middle_name",
              ].includes(keys[i])
            ) {
              if (keys[i] === "title_name") {
                jsonName[keys[i]] = this.mapDataOptions(
                  this.optionTitle,
                  this.dataTable[listUp][keys[i]]
                );
              } else if (keys[i] === "academic_title") {
                jsonName[keys[i]] = this.mapDataOptions(
                  this.optionAcademicTitle,
                  this.dataTable[listUp][keys[i]]
                );
              } else {
                jsonName[keys[i]] = this.dataTable[listUp][keys[i]];
              }
            }
            // -----> former name
            else if (
              [
                "former_eng_first_name",
                "former_eng_last_name",
                "former_eng_middle_name",
                "former_thai_first_name",
                "former_thai_last_name",
                "former_thai_middle_name",
              ].includes(keys[i])
            ) {
              jsonFormerName[keys[i].replace("former_", "")] =
                this.dataTable[listUp][keys[i]];
            }

            // -----> main contact
            else if (
              [
                "address",
                "email",
                "social_instagram",
                "social_facebook",
                "social_line",
                "phone_number",
                "phone_home",
              ].includes(keys[i])
            ) {
              jsonContact[keys[i]] =
                keys[i] === "email"
                  ? this.dataTable[listUp][keys[i]] !== "-"
                    ? this.dataTable[listUp][keys[i]]
                    : ""
                  : this.dataTable[listUp][keys[i]];
            }
            // -----> former contact
            else if (
              [
                "former_address",
                "former_email",
                "former_social_instagram",
                "former_social_facebook",
                "former_social_line",
                "former_phone_number",
                "former_phone_home",
              ].includes(keys[i])
            ) {
              jsonFormerContact[keys[i].replace("former_", "")] =
                keys[i] === "former_email"
                  ? this.dataTable[listUp][keys[i]] !== "-"
                    ? this.dataTable[listUp][keys[i]]
                    : ""
                  : this.dataTable[listUp][keys[i]];
            }
          }

        }
        // send to api insert
        this.uploadMainProfile(
          listUp,
          this.dataTable[listUp]["sequence"],
          jsonBody,
          jsonName,
          jsonFormerName,
          jsonContact,
          jsonFormerContact
        );
        // ////console.log(jsonBody);
        // ////console.log('<--------------------->')
      }
      // this.isLoaded = true;
    },
    updateMainProfile(id, jsonData) {
      return new Promise((resolve) => {
        this.$http
          .patch(
            "/student_affair/alumni-profile/" + id + "/",
            jsonData
          )
          .then((response) => {
            if (response.status) {
              resolve(true);
            }
          })
          .catch((error) => {
            resolve(false);
          });
      });
    },
    async uploadMainProfile(
      recIndex,
      loopIndex,
      jsonMainProfile,
      jsonName,
      jsonFormerName,
      jsonContact,
      jsonFormerContact
    ) {
      this.indexLoad = loopIndex;
      this.indexErrorName = [];
      this.indexErrorContact = [];
      let status = "";
      let arrUpdate = []
      // ---> create profile
      // ////console.log(jsonMainProfile['alumin_name'])
      // ////console.log(jsonMainProfile['alumin_contact'])
      try {
        const resA = await this.$http.post(
          "/student_affair/alumni-profile/",
          jsonMainProfile
        );
        if (resA.status === 201) {
          // ////console.log(resA.data.id);
          var jsonBodyPatch = {};
          // ---> create name
          const responses = [];
          const nameList = [jsonFormerName, jsonName]; // Former ก่อน

          for (const el of nameList) {
            if (el.eng_first_name !== "-" && el.eng_last_name !== "-") {
              const res = await this.$http.post(
                "/student_affair/alumni-profile-name/",
                el
              );

              if (res?.data?.id) {
                responses.push(res.data.id);
              }
            }
          }

          // ---> create name
          jsonBodyPatch['alumin_name'] = responses

          // ---> create contact
          const responsesContact = [];

          const hasContactData = (obj) => {
            return [
              obj.email,
              obj.address,
              obj.phone_number,
              obj.phone_home,
              obj.social_instagram,
              obj.social_facebook,
              obj.social_line
            ].some(v => !['-', '', null, 'null'].includes(v));
          };

          /* =========================
             1️ ยิง Former Contact ก่อน
          ========================= */

          if (hasContactData(jsonFormerContact)) {
            const formerRes = await this.$http.post(
              "/student_affair/alumni-profile-contact/",
              jsonFormerContact
            );

            if (formerRes?.data?.id) {
              responsesContact.push(formerRes.data.id);
            }
          }
          /* =========================
             2 ยิง Current Contact ทีหลัง
          ========================= */

          if (hasContactData(jsonContact)) {
            const currentRes = await this.$http.post(
              "/student_affair/alumni-profile-contact/",
              jsonContact
            );

            if (currentRes?.data?.id) {
              responsesContact.push(currentRes.data.id);
            }
          }

          jsonBodyPatch['alumin_contact'] = responsesContact;

          // ---> Patch profile
          // await this.updateMainProfile(resA.data.id, jsonBodyPatch)
          this.$http
            .patch(`/student_affair/alumni-profile/${resA.data.id}/`, jsonBodyPatch)
            .then((response) => {
              if (response.status) {
                jsonBodyPatch = {};
                resolve(true);
              }
            })
            .catch((error) => {
              resolve(false);
            });
          //moss
          this.dataTable[recIndex]['status_import'] = 'complete'
          this.importComplete++
          //p north
          this.countInsert++;
          jsonMainProfile["alumin_name"] = [];
          jsonMainProfile["alumin_contact"] = [];
          // update success
          status = 'success'
          this.processImport[loopIndex] = {
            ...this.processImport[loopIndex],
            status
          }
          arrUpdate.push(this.processImport[loopIndex]);
          this.processImport.splice(loopIndex, 1, arrUpdate[0]);
          arrUpdate = []
          this.indexLoad = ''

        } else {
          throw resA
        }
      } catch (error) {
        // update error
        //moss
        this.importFailed++
        this.dataTable[recIndex]['status_import'] = 'error'
        this.dataTable[recIndex]['status_detail'] = 'Duplicate student ID or Other Error'
        //p north
        this.countInsert++;
        status = 'error'
        this.processImport[loopIndex] = {
          ...this.processImport[loopIndex],
          status
        }
        arrUpdate.push(this.processImport[loopIndex]);
        this.processImport.splice(loopIndex, 1, arrUpdate[0]);
        arrUpdate = []
        this.indexLoad = ''

      }
      // ---> create profile
      //console.log(this.countInsert,parseInt(this.dataTable.length))
      if (this.countInsert == parseInt(this.dataTable.length)) {
        this.countInsert = 0;
        this.isLoaded = true;
        // this.$emit("hideModal");
      }

    },
    mapDataOptions(arr, value) {
      let result = "";
      let filterObj = arr.filter(
        (item) => item.textEn.toLowerCase() === value.toLowerCase()
      );
      try {
        if (filterObj.length === 0) {
          let filterObjB = arr.filter(
            (item) => item.textEn.toLowerCase() === "-"
          );
          result = filterObjB[0].id;
        } else {
          result = filterObj[0].id;
        }
      } catch (e) {
      }
      return result
    },
    mapDataOptionsText(arr, value) {
      let resultText = "";
      let filterObj = arr.filter((item) => item.id === value);
      try {
        if (filterObj.length === 0) {
          let filterObjB = arr.filter(
            (item) => item.textEn.toLowerCase() === "-"
          );
          resultText = filterObjB[0].textEn;
        } else {
          resultText = filterObj[0].textEn;
        }
      }
      catch (e) {
      }
      return resultText;
    },
  },
};
</script>
<style>
.modal-info {
  overflow-y: scroll;
  max-height: 500px;
}
</style>